export const SUBJECT_ID_ENGLISH = 1;
export const SUBJECT_ID_MATH = 2;
export const SUBJECT_ID_SCIENCE = 3;
export const SUBJECT_ID_CHINESE = 4;
export const SUBJECT_ID_EMATH = 7;
export const SUBJECT_ID_AMATH = 8;
export const SUBJECT_ID_PHYSICS = 9;
export const SUBJECT_ID_CHEMISTRY = 10;
export const SUBJECT_ID_BIOLOGY = 11;
export const SUBJECT_ID_CHINESE_2 = 19;
export const SUBJECT_ID_CHINESE_3 = 20;
export const SUBJECT_ID_CHINESE_4 = 21;
export const SUBJECT_ID_INVESTMENT = 23;
export const SUBJECT_ID_CSPHYSICS = 24;
export const SUBJECT_ID_FOUNDATION_MATH = 25;
export const SUBJECT_ID_YLE = 26;
export const SUBJECT_ID_VIETNAM_MATH = 27;
export const SUBJECT_ID_CSCHEMISTRY = 28;
export const SUBJECT_ID_CSPHYSICSNA = 29;
export const SUBJECT_ID_CSCHEMISTRYNA = 30;
export const SUBJECT_ID_TEMP = 31; //* subject ID temporary for small class
export const SUBJECT_ID_A2ENGLISH = 32;
export const SUBJECT_ID_B1ENGLISH = 33;
export const SUBJECT_ID_B2ENGLISH = 34;
export const SUBJECT_ID_CHEMISTRY_O_LEVEL = 35;
export const SUBJECT_ID_PHYSICS_O_LEVEL = 36;
export const SUBJECT_ID_CSCHEMISTRY_O_LEVEL = 37;
export const SUBJECT_ID_CSPHYSICS_O_LEVEL = 38;
export const SUBJECT_ID_CSCHEMISTRY_NA_LEVEL = 39;
export const SUBJECT_ID_CSPHYSICS_NA_LEVEL = 40;
export const SUBJECT_ID_YL = 41;
export const SUBJECT_ID_BIOLOGY_O_LEVEL = 42;
export const SUBJECT_ID_GENIUM_ENGLISH = 46;
export const SUBJECT_ID_GENIUM_MATHEMATICS = 47;
export const SUBJECT_ID_CHINESE_ADD_ON = 48;
export const SUBJECT_ID_SCA = 49;
export const SUBJECT_ID_DO = 50;

export const EXAM_RESULTS_BUBBLES_REWARD = '20';
// Primary Grade
export const PRIMARY_GRADES = [
  {
    name: 'AL1',
    grade_id: 1,
  },
  {
    name: 'AL2',
    grade_id: 2,
  },
  {
    name: 'AL3',
    grade_id: 3,
  },
  {
    name: 'AL4',
    grade_id: 4,
  },
  {
    name: 'AL5',
    grade_id: 5,
  },
  {
    name: 'AL6',
    grade_id: 6,
  },
  {
    name: 'AL7',
    grade_id: 7,
  },
  {
    name: 'AL8',
    grade_id: 8,
  },
  {
    name: 'Not Applicable',
    grade_id: -1,
  },
];
// Secondary Grades
export const SECONDARY_GRADES = [
  {
    name: 'A1',
    grade_id: 9,
  },
  {
    name: 'A2',
    grade_id: 10,
  },
  {
    name: 'B3',
    grade_id: 11,
  },
  {
    name: 'B4',
    grade_id: 12,
  },
  {
    name: 'C5',
    grade_id: 13,
  },
  {
    name: 'C6',
    grade_id: 14,
  },
  {
    name: 'D7',
    grade_id: 15,
  },
  {
    name: 'E8',
    grade_id: 16,
  },
  {
    name: 'F9',
    grade_id: 17,
  },
  {
    name: 'Not Applicable',
    grade_id: -1,
  },
];

export const PRIMARY_SECONDARY_GRADES = [
  {
    name: 'A1',
    grade_id: 1,
  },
  {
    name: 'AL2',
    grade_id: 2,
  },
  {
    name: 'AL3',
    grade_id: 3,
  },
  {
    name: 'AL4',
    grade_id: 4,
  },
  {
    name: 'AL5',
    grade_id: 5,
  },
  {
    name: 'AL6',
    grade_id: 6,
  },
  {
    name: 'AL7',
    grade_id: 7,
  },
  {
    name: 'AL8',
    grade_id: 8,
  },
  {
    name: 'A1',
    grade_id: 9,
  },
  {
    name: 'A2',
    grade_id: 10,
  },
  {
    name: 'B3',
    grade_id: 11,
  },
  {
    name: 'B4',
    grade_id: 12,
  },
  {
    name: 'C5',
    grade_id: 13,
  },
  {
    name: 'C6',
    grade_id: 14,
  },
  {
    name: 'D7',
    grade_id: 15,
  },
  {
    name: 'E8',
    grade_id: 16,
  },
  {
    name: 'F9',
    grade_id: 17,
  },
  {
    name: 'Band 1',
    grade_id: 18,
  },
  {
    name: 'Band 2',
    grade_id: 19,
  },
  {
    name: 'Band 3',
    grade_id: 20,
  },
  {
    name: 'Band 4',
    grade_id: 21,
  },
  {
    name: 'Not Applicable',
    grade_id: -1,
  },
];

export const SUBJECTS_USE_MATH_COLOR = [
  SUBJECT_ID_MATH,
  SUBJECT_ID_INVESTMENT,
  SUBJECT_ID_EMATH,
  SUBJECT_ID_AMATH,
  // SUBJECT_ID_VN_MATH,
  SUBJECT_ID_FOUNDATION_MATH,
];
export const SUBJECTS_USE_ENGLISH_COLOR = [
  SUBJECT_ID_ENGLISH,
  SUBJECT_ID_YL,
  SUBJECT_ID_YLE,
  // SUBJECT_ID_A2_ENGLISH,
  // SUBJECT_ID_B1_ENGLISH,
  // SUBJECT_ID_B2_ENGLISH,
];
export const SUBJECTS_USE_CHINESE_COLOR = [
  SUBJECT_ID_CHINESE,
  SUBJECT_ID_CHINESE_2,
  SUBJECT_ID_CHINESE_3,
  SUBJECT_ID_CHINESE_4,
];
export const SUBJECTS_USE_SCIENCE_COLOR = [
  SUBJECT_ID_SCIENCE,
  SUBJECT_ID_PHYSICS,
  // physic new syllabus
  // SUBJECT_ID_CS_PHYSICS,
  // cs physics new syllabus
  // SUBJECT_ID_CS_PHYSICS_NA,

  SUBJECT_ID_BIOLOGY,
];

export const EXAM_RESULT_PENDING_STATUS = 0;
export const EXAM_RESULT_APPROVED_STATUS = 1;
export const EXAM_RESULT_REJECTED_STATUS = 2;
